// extracted by mini-css-extract-plugin
export default {"button":"AwardButton_button__c1xGB"};